import * as React from 'react'
import { cn } from '../../lib/utils'
import { Counter } from './Counter'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../lib/ui/form'
import { Textarea } from '../../lib/ui/textarea'

export function TextareaField({
  description,
  placeholder,
  name,
  label,
  control,
  programSurvey = false,
  textAreaClassName,
}) {
  const fieldId = React.useId()
  const maxLength = 500

  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const helpId = `${fieldId}-help`
        const descriptionId = `${fieldId}-description`
        const counterId = `${fieldId}-counter`
        const errorId = `${fieldId}-error`
        const describedBy = [
          programSurvey ? helpId : null,
          descriptionId,
          programSurvey ? counterId : null,
          fieldState.error ? errorId : null,
        ]
          .filter(Boolean)
          .join(' ')

        return (
          <FormItem>
            <FormLabel id={`${fieldId}-label`} className="leading-normal">
              {label}
            </FormLabel>
            {programSurvey && (
              <FormDescription
                id={helpId}
                className="mt-4 text-sm text-[#5d5d5d]"
              >
                Short answer
              </FormDescription>
            )}
            <div className={programSurvey ? ' !mt-12' : ''}>
              <FormControl>
                <Textarea
                  placeholder={placeholder}
                  className={cn(
                    'h-[114px] resize-none border-[#b0b0b0]',
                    textAreaClassName,
                  )}
                  {...field}
                  maxLength={maxLength}
                  aria-labelledby={`${fieldId}-label`}
                  aria-describedby={describedBy}
                  aria-invalid={fieldState.invalid}
                />
              </FormControl>
              {programSurvey && (
                <div id={counterId} aria-live="polite">
                  <Counter value={field.value} maxLength={maxLength} />
                </div>
              )}
            </div>
            <FormDescription id={descriptionId}>{description}</FormDescription>
            <FormMessage id={errorId} aria-live="polite" />
          </FormItem>
        )
      }}
    />
  )
}
